import style from "../../../../routes/home/style.module.scss"
import AudioPlayer from "../../../../components/mainLayout/audio";
import audio from "../../../../assets/audio/48.mp3"
import MoreInfo from "../../../../components/moreInfo";

export default function P1() {
    return (
        <div className={style.mainLayout}>
            <MoreInfo />
            <div className={style.content}>

                <h1>Podziękowania</h1>

                <AudioPlayer audioSrc={audio} />

                <div className={style.text}>
                    <h2>
                        Dziękujemy, że byliście częścią tej podróży!
                    </h2>
                    <p>
                        Chcemy też złożyć serdeczne podziękowania osobom zaangażowanym we współpracę przy realizacji projektu:
                    </p>
                    <p>
                        burmistrzowi gminy Zagórów Romanowi Kultermanowi, Zdzisławowi Kulawinkowi, Aleksandrze Tomaszewskiej, Stanisławowi Niemojewskiemu, Kamili Krupińskiej, Filipowi Jeglińskiemu, Arlecie Wilczyńskiej, Marcie Matyjaszek, Jackowi Burdzie, Karolowi Mazurowi, Lilli Lebiedzińskiej, Danielowi Słowińskiemu, Piotrowi Łakomiakowi, Wiesławie Kowalskiej, Przemysławowi Kowalskiego, Mirosławowi Słowińskiemu, Katarzynie Połom, Krystynie Szelewicz-Cichockiej, Bogdanowi Michalskiemu, Jerzemu Napierale, Ziporze Lazar, Grzegorzowi Cieślewiczowi, pastorowi Waldemarowi Wunszowi, Małgorzacie Iwanickiej, Pauli Przetakowskiej, Michałowi Januszkiewiczowi, Andrzejowi Bernatowi i Joannie Bordo-Krupie.

                    </p>
                    <p>
                        Bez ich wsparcia nie byłoby możliwe zrealizowanie tej inspirującej inicjatywy.
                    </p>
                </div>
            </div>
        </div>
    );
}